import * as React from "react";
import { merge, $ } from "glamor";
import { DATATEST } from "../../../constants/integration";

const SalesRep = ({ model }) => {
    const styles = merge(
        {
            color: "#E9E9E9",
            fontSize: "14px",
            fontFamily: "Cardo, sans-serif",
            margin: "15px",
            flexBasis: "200px",
        },
        $(" > .title", {
            fontWeight: "bold",
            textTransform: "uppercase",
            fontFamily: "Cardo, sans-serif",
        }),
        $(" > .alternate", {
            color: "#BFBFBF",
        }),
        $(" > .link", {
            fontWeight: "bold",
            textDecoration: "underline",
            position: "inherit",
            color: "#E9E9E9",
            display: "inline-block",
        })
    );
    return (
        <div {...styles}>
            <div data-test={DATATEST.LOGIN.SALES_CONTACT_TITLE} className="title">
                {model.title}
            </div>
            <div data-test={DATATEST.LOGIN.SALES_CONTACT_NAME} className="alternate">
                {model.name}
            </div>
            <a data-test={DATATEST.LOGIN.SALES_CONTACT_EMAIL} className="link" href={`mailto:${model.email}`}>
                {model.email}
            </a>
            {model.phone ? (
                <div data-test={DATATEST.LOGIN.SALES_CONTACT_PHONE} className="alternate">
                    {model.phone}
                </div>
            ) : null}
        </div>
    );
};

export { SalesRep };
export default SalesRep;
